import authenticated from "../middleware/authenticated";
import guest from "../middleware/guest";
import authorized from "../middleware/authorized";

export default [
    {
        path: '/employee-login',
        name: 'EmployeeLoginPage',
        component: () => import(/* webpackChunkName: "employeeIndexPage" */'../../views/EmployeeLogin.vue'),
        meta: {
            middleware: [guest],
        }
    },
    {
        path: '/auth-ekyzmat',
        name: 'AuthEkyzmat',
        component: () => import(/* webpackChunkName: "authEkyzmat" */'../../views/AuthEkyzmat.vue'),
        meta: {
            middleware: [guest],
        }
    },
    {
        path: '/employee',
        meta: {
            middleware: [authenticated],
        },
        component: () => import(/* webpackChunkName: "employeeLayout" */ '../../views/employee/Layout.vue'),
        children: [
            {
                path: '',
                name: 'Employee',
                component: () => import(/* webpackChunkName: "Employee" */ '../../views/employee/Index.vue'),
            },
            {
                path: 'profile',
                name: 'EmployeeProfileDetail',
                component: () => import(/* webpackChunkName: "EmployeeProfileDetail" */ '../../views/employee/profile/Detail.vue'),
            },

            {
                path: 'applications',
                name: 'EmployeeApplicationsLayout',
                component: () => import(/* webpackChunkName: "EmployeeApplicationsList" */ '../../views/employee/applications/Layout.vue'),
                meta: {
                    middleware: [authenticated, authorized],
                    roles: [
                        'ROLE_SINGLE_WINDOW',
                        'ROLE_LAWYER',
                        'ROLE_DIRECTOR',
                        'ROLE_SUB_DIRECTOR',
                        'ROLE_MANAGER',
                        'ROLE_EMPLOYMENT',
                        'ROLE_ACCOUNTANT',
                        'ROLE_VIEWER'
                    ],
                },
                children: [
                    {
                        path: '',
                        name: 'EmployeeApplicationsList',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsList" */ '../../views/employee/applications/List.vue'),
                    },
                    {
                        path: 'waiting-registration',
                        name: 'EmployeeApplicationsWaitingRegistration',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsWaitingRegistration" */ '../../views/employee/applications/WaitingRegistration.vue'),
                    },
                    {
                        path: 'waiting-send-to-applicant',
                        name: 'EmployeeApplicationsWaitingSendToApplicant',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsWaitingSendToApplicant" */ '../../views/employee/applications/WaitingSendToApplicant.vue'),
                    },
                    {
                        path: 'for-sign',
                        name: 'EmployeeApplicationsForSign',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsForSign" */ '../../views/employee/applications/ForSign.vue'),
                    },
                    {
                        path: 'on-confirm-payment',
                        name: 'EmployeeApplicationsOnConfirmPayment',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsOnConfirmPayment" */ '../../views/employee/applications/OnConfirmPayment.vue'),
                    },
                    {
                        path: 'on-pending',
                        name: 'EmployeeApplicationsOnPending',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsOnPending" */ '../../views/employee/applications/OnPending.vue'),
                    },
                    {
                        path: 'you-curator',
                        name: 'EmployeeApplicationsYouCurator',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsYouCurator" */ '../../views/employee/applications/YouCurator.vue'),
                    },
                    {
                        path: 'to-resolution',
                        name: 'EmployeeApplicationsToResolution',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsYouCurator" */ '../../views/employee/applications/ToResolution.vue'),
                    },
                    {
                        path: 'you-responsible',
                        name: 'EmployeeApplicationsYouResponsible',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsYouResponsible" */ '../../views/employee/applications/YouResponsible.vue'),
                    },
                    {
                        path: 'department-curator',
                        name: 'EmployeeApplicationsDepartmentCurator',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsDepartmentCurator" */ '../../views/employee/applications/DepartmentCurator.vue'),
                    },
                    {
                        path: 'department-responsible',
                        name: 'EmployeeApplicationsDepartmentResponsible',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsDepartmentResponsible" */ '../../views/employee/applications/DepartmentResponsible.vue'),
                    },
                    {
                        path: 'egrz',
                        name: 'EmployeeEgrzApplicationsList',
                        component: () => import(/* webpackChunkName: "EmployeeEgrzApplicationsList" */ '../../views/employee/applications/Egrz.vue'),
                    },
                    {
                        path: ':applicationId',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsApplicationDetailLayout" */ '../../views/employee/applications/application/DetailLayout.vue'),
                        children: [
                            {
                                path: 'resolutions/list',
                                name: 'EmployeeApplicationsResolutionsList',
                                component: () => import(/* webpackChunkName: "EmployeeApplicationsResolutionsList" */ '../../views/employee/applications/application/resolutions/List.vue'),
                            },
                            {
                                path: 'resolutions/:resolutionId',
                                name: 'EmployeeApplicationsResolutionsDetail',
                                component: () => import(/* webpackChunkName: "EmployeeApplicationsResolutionsDetail" */ '../../views/employee/applications/application/resolutions/resolution/Detail.vue'),
                            },
                        ]
                    },

                    {
                        path: 'egrz/:applicationId',
                        name: 'EmployeeApplicationsEgrzApplication',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsEgrzApplication" */ '../../views/employee/applications/application/Egrz.vue'),
                    },
                ]
            },

            {
                path: 'application/:applicationId/old',
                component: () => import(/* webpackChunkName: "EmployeeApplicationsApplicationDetailLayout" */ '../../views/employee/applications/application/DetailLayout.vue'),
                meta: {
                    breadcrumb: {
                        ref: 'APPLICATION',
                        route: 'EmployeeApplicationsResolutionsList',
                    },
                    sidebar: 'slidable',
                },
                children: [
                    {
                        path: '',
                        name: 'EmployeeApplicationsResolutionsList',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsResolutionsList" */ '../../views/employee/applications/application/resolutions/List.vue'),
                    },
                    {
                        path: 'resolutions/:resolutionId',
                        name: 'EmployeeApplicationsResolutionsDetail',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationsResolutionsDetail" */ '../../views/employee/applications/application/resolutions/resolution/Detail.vue'),
                        meta: {
                            breadcrumb: {
                                ref: 'RESOLUTION',
                                route: 'EmployeeApplicationsResolutionsDetail',
                            },
                        }
                    },
                ]
            },

            {
                path: 'application/:applicationId',
                name: 'EmployeeApplicationLayout',
                component: () => import(/* webpackChunkName: "EmployeeApplicationDetail" */ '../../views/employee/application/Layout.vue'),
                children: [
                    {
                        path: 'main',
                        name: 'EmployeeApplicationMain',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationMain" */ '../../views/employee/application/Main.vue'),
                    },
                    {
                        path: 'agreement',
                        name: 'EmployeeApplicationAgreement',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationAgreement" */ '../../views/employee/application/Agreement.vue'),
                    },
                    {
                        path: 'documents',
                        name: 'EmployeeApplicationDocuments',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationDocuments" */ '../../views/employee/application/Documents.vue'),
                    },
                    {
                        path: 'resolutions',
                        name: 'EmployeeApplicationResolutions',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationResolutions" */ '../../views/employee/application/Resolutions.vue'),
                        children: [
                            {
                                path: ':resolutionId',
                                name: 'EmployeeApplicationResolution',
                                component: () => import(/* webpackChunkName: "EmployeeApplicationResolution" */ '../../views/employee/application/resolution/Detail.vue'),
                            }
                        ]
                    },
                    {
                        path: 'additional-files',
                        name: 'EmployeeApplicationAdditionalFiles',
                        component: () => import(/* webpackChunkName: "EmployeeApplicationAdditionalFiles" */ '../../views/employee/application/AdditionalFiles.vue'),
                    },
                ]
            },

            {
                path: 'reports',
                name: 'EmployeeReports',
                component: () => import(/* webpackChunkName: "EmployeeReports" */ '../../views/employee/reports/Index.vue'),
            },
        ]
    }
];
